import { ReactElement, Suspense, useState } from 'react';
import { Typography, Spin, Segmented } from 'antd';
import { ApplicationTable, StyledRow, Cell, HonbuSwitch } from './styles';
import Rows from './Rows';
import { HONBU_LABEL, type Honbu } from '../types';

const { Title } = Typography;

const HONBU_OPTIONS: { label: string; value: Honbu }[] = [
  { label: HONBU_LABEL['1honbu'], value: '1honbu' },
  { label: HONBU_LABEL['2honbu'], value: '2honbu' },
];

const List = (): ReactElement => {
  const [honbu, setHonbu] = useState<Honbu>('1honbu');

  return (
    <section>
      <Title level={4}>架電履歴</Title>
      <HonbuSwitch>
        <Segmented<Honbu> options={HONBU_OPTIONS} value={honbu} onChange={setHonbu} />
      </HonbuSwitch>
      <ApplicationTable>
        <StyledRow>
          <Cell>ID</Cell>
          <Cell>RPM応募者ID</Cell>
          <Cell>電話番号</Cell>
          <Cell>氏名</Cell>
          <Cell>氏名（カナ）</Cell>
          <Cell>申込者ステータス</Cell>
          <Cell>架電結果</Cell>
          <Cell>架電日時</Cell>
        </StyledRow>
        <Suspense fallback={<Spin />}>
          <Rows honbu={honbu} />
        </Suspense>
      </ApplicationTable>
    </section>
  );
};

export default List;
